'use strict';

export function init() {
    const eventHeader = document.querySelector('.js-event-header');
    const eventStickyBar = document.querySelector('.event-sticky-bar');
    const contentBlocks = document.querySelector('.content-blocks');
    const eventHeaderMedia = document.querySelector('.event-header__media');

    if (eventHeader && eventStickyBar && contentBlocks) {
        eventStickyBar.style.display = 'block';

        const myScrollFunc = function() {
            const rect = contentBlocks.getBoundingClientRect();
            let triggerPoint;
            // Setting a manuial trigger point if there is no image on the event page
            // This will stop the event navigation from being stuck open.
            if (eventHeaderMedia) {
                triggerPoint = window.innerHeight / 2;
            } else {
                triggerPoint = 100;
            }

            if (rect.top <= triggerPoint) {
                eventStickyBar.classList.add('show');
            } else {
                eventStickyBar.classList.remove('show');
            }
        };

        window.addEventListener('scroll', myScrollFunc, { passive: true });
    }
}
